/* src/app/modules/shared/components/column/column-growing-conditions/column-growing-conditions.component.scss */
app-column-growing-conditions {
  display: contents;
}
/*# sourceMappingURL=column-growing-conditions.component.css.map */
